import { Typography } from "@mui/material";
import { currencyFormatter } from "../../../utils/AgGridUtils/ColumnBuilders/createColumn";
import { _CO, _MONTHS } from "../../../utils/constants";
import { createColumn } from "../../../utils/function";
import {
  GROSS_PROFITS_P,
  GROSS_PROFITS_RS_T,
  SELLING_PRICE_INCREASE,
  SELLING_PRICE_RS_T,
  TURNOVER_LRL_RS,
  INTERNAL_SALES_VALUE,
} from "./AgGridTurnoverLrl";
import {
  processRowsIncludeTurnoverSellingPrice,
  processRowsGrossProfitsRsT,
  processRowsGrossProfitsP,
  processRowsTurnoverLrlRs,
} from "./function-turnover-lrl";

export const ColumnBuilder = ({ budgetParameters } = {}, grossProfitsP) => {
  const buildColumns = () => {
    const generatedColumns = [];

    generatedColumns.push(
      ...createColumn([
        {
          headerName: "",
          field: "theme",
          rowGroup: true,
          hide: true,
          cellRenderer: (params) => {
            return params.data.theme;
          },
          supressCount: true,
        },
        {
          headerName: "Price",
          field: "rate",
          editable: (params) => {
            return params.data?.theme === SELLING_PRICE_RS_T;
          },
          flex: 1,
          cellRenderer: (params) => {
            return params.data?.theme === SELLING_PRICE_RS_T ? (
              <strong>{currencyFormatter(params?.value, "", 2)}</strong>
            ) : (
              ""
            );
          },
        },
        {
          headerName: "Sources",
          field: "subThemes",
          flex: 3.5,
          cellRenderer: (params) => {
            const { node } = params;

            if (node.footer && node.key === TURNOVER_LRL_RS) {
              return INTERNAL_SALES_VALUE;
            }

            return (
              <Typography variant="body2" title={params.data?.subThemes}>
                {params.data?.subThemes}
              </Typography>
            );
          },
        },
      ]),
    );

    for (let i = 1; i <= 12; i++) {
      const fiscalMonthIndex = _CO[i];
      generatedColumns.push(
        ...createColumn([
          {
            headerName: _MONTHS[fiscalMonthIndex],
            field: `${fiscalMonthIndex}`,
            editable: (params) => {
              return (
                params.data?.subThemes === "Selling Price Increase" &&
                params.colDef.field !== "rate" &&
                params.colDef.field !== "total" &&
                params.colDef.field !== "subThemes"
              );
            },
            headerClass: "month-header",
            aggFunc: "sum",
            flex: 1,
            valueGetter: (params) => {
              const { api, data, node } = params;

              switch (true) {
                case data &&
                  data?.rate &&
                  data?.subThemes !== SELLING_PRICE_INCREASE:
                  return processRowsIncludeTurnoverSellingPrice(
                    data,
                    api,
                    node,
                    i,
                  );

                case data?.theme === GROSS_PROFITS_RS_T:
                  return processRowsGrossProfitsRsT(
                    data,
                    api,
                    node,
                    i,
                    grossProfitsP,
                  );

                case data?.theme === GROSS_PROFITS_P:
                  return processRowsGrossProfitsP(data, api, node, i);

                case data?.theme === TURNOVER_LRL_RS:
                  return processRowsTurnoverLrlRs(data, api, node, i);

                default:
                  const value = Number(data?.[fiscalMonthIndex] || 0);

                  return Number(value.toFixed(2));
              }
            },
            valueParser: (params) => {
              if (params.newValue == null) {
                return 0;
              }

              const valueAsString = String(params.newValue);

              const cleanValue = valueAsString
                .replace(/\s/g, "")
                .replace(/,/g, ".");

              return parseFloat(cleanValue) || 0;
            },
            cellRenderer: (params) => {
              if (!params.value) return "";

              if (params.data?.theme === SELLING_PRICE_RS_T) {
                return (
                  <Typography
                    variant="body2"
                    title={currencyFormatter(params?.value, "", 2)}
                  >
                    {currencyFormatter(params.value, "", 2)}
                  </Typography>
                );
              }

              if (params.data?.theme === GROSS_PROFITS_P) {
                return (
                  <Typography
                    variant="body2"
                    title={currencyFormatter(params?.value, "%")}
                    style={{
                      color: params.value > 100 ? "red" : "inherit",
                    }}
                  >
                    {currencyFormatter(params.value, "%")}
                  </Typography>
                );
              }

              return (
                <Typography
                  variant="body2"
                  title={currencyFormatter(params?.value, "")}
                >
                  {currencyFormatter(params.value, "")}
                </Typography>
              );
            },
          },
        ]),
      );
    }

    generatedColumns.push(
      ...createColumn([
        {
          headerName: "TOTAL",
          field: "total",
          headerClass: "total-header-col",
          aggFunc: "sum",
          flex: 1,

          valueGetter: (params) => {
            const { data } = params;

            if (!data || data?.theme === SELLING_PRICE_RS_T) return 0;

            const total = Array.from({ length: 12 }, (_, i) => i + 1).reduce(
              (sum, month) => sum + (Number(data?.[month]) || 0),
              0,
            );

            return Number(total.toFixed(2));
          },
          cellRenderer: (params) => {
            if (
              params.value === null ||
              params.data?.theme === SELLING_PRICE_RS_T ||
              params.data?.theme === GROSS_PROFITS_RS_T ||
              params.data?.theme === GROSS_PROFITS_P
            ) {
              return "";
            }

            return (
              <Typography
                variant="body2"
                title={currencyFormatter(params?.value, "")}
              >
                {currencyFormatter(params.value, "")}
              </Typography>
            );
          },
        },
      ]),
    );

    return generatedColumns;
  };

  return buildColumns();
};
